// achievements.js

const achievementsData = [
  {
    id: 1,
    title: "Oracle Cloud Infrastructure (OCI) Certification",
    issuer: "Oracle",
    date: "2024-08", // Placeholder: Replace with actual date
    description: "Successfully completed formal certification demonstrating proficiency in Oracle's cloud infrastructure platform.",
    // 🔥 Your provided link for Oracle Certification
    certificateUrl: "https://drive.google.com/file/d/1TPbJcN1phRj6iELJ_BMrO6fsump5UUHE/view?usp=sharing", 
    // Placeholder image path for the badge/logo
    imageUrl: "/oracle.png", 
  },
  {
    id: 2,
    title: "Introduction to Web Design Course",
    issuer: "Course Provider", // Placeholder: Replace with actual course name/provider
    date: "2023-11", // Placeholder: Replace with actual date
    description: "Mastered fundamental principles of web design, covering HTML5, CSS3, responsive layouts, and user experience basics.",
    // 🔥 Your provided link for Web Design
    certificateUrl: "https://drive.google.com/file/d/1bWnLV6m-LvFRBjTuVdlzYdCTktHILLt_/view?usp=sharing",
    // Placeholder image path for the badge/logo
    imageUrl: "/great.png", 
  },
  {
    id: 3,
    title: "Generative AI Fundamentals in Oracle Cloud",
    issuer: "Oracle",
    date: "2024-07", // Placeholder: Replace with actual date
    description: "Completed comprehensive training on Generative AI concepts, tools, and responsible application within the Oracle ecosystem.",
    // 🔥 Your provided link for Generative AI
    certificateUrl: "https://drive.google.com/file/d/1LonZA_AR10KAEKCcW7ckZY1ZysoM4X6u/view?usp=sharing",
    // Placeholder image path for the badge/logo
    imageUrl: "/oracle.png",
  },
];

export default achievementsData;